import React, { useEffect, useRef, useState } from 'react';
import {
  saveToHistory,
  getUpdatablePermissionsByUser,
  GetOrgUserList,
  setOrderList,
  setFilterList,
  setCurrentPage,
  setUsersList,
  setDataIndexToLoad,
  setSelectedUser,
  resetTempList,
  setCurrentDataIndex,
  setActionType,
} from './OrgUsersManagementSlice';
import { connect } from 'react-redux';
import { UserTableColumn, Error, StatusTextAndColor, UserStatus, getStatusTextAndColor } from './General';
import FilterTable from './FilterTable';
//import * as signalR from '@microsoft/signalr';
import Image from 'app/Components/Shared/Image/image';
const OrgUsersTable = (props) => {
  const containerRef = useRef();
  const [usersToDisplay, setUsersToDisplay] = useState([]);
  const userPerPage = 7;
  const countOfPagePerLoad = 14;
  const preloadPageOffset = 3;
  const maxDataIndex = (props.data.countOfRows / (userPerPage * countOfPagePerLoad)).toFixed(0);
  const totalPages = Math.ceil(props.data.countOfRows / userPerPage);
  const [searchErrValue, setSearchErrValue] = useState('');
  const [showPrevList, setShowPrevList] = useState(false);

  useEffect(() => {
    if(props.allowActivate && props.allowUpgrade) {
      props.setActionType('');
    } else if (!props.allowActivate && props.allowUpgrade){
      props.setActionType('upgrade');
    } else if (props.allowActivate && !props.allowUpgrade){
      props.setActionType('activate');
    }
  }, []);

  useEffect(() => {
    var users = props.data.usersList.slice(0, userPerPage);
    setUsersToDisplay(users);
  }, [props.data.usersList]);

  useEffect(() => {
    props.saveToHistory('UserList');
    // const connection = new signalR.HubConnectionBuilder()
    //   .withUrl('http://localhost:5001/OrgUserHub', {
    //     skipNegotiation: true,
    //     transport: signalR.HttpTransportType.WebSockets,
    //   })
    //   .configureLogging(signalR.LogLevel.Information)
    //   .build();
    // connection.on('ReceiveUserUpdate', (userId, userDetails) => {
    //   console.log(userDetails);
    // });
    // connection
    //   .start()
    //   .then(() => console.log('Connected to the hub'))
    //   .catch((err) => console.log('Error while establishing connection', err));
    // return () => {
    //   connection.stop();
    // };
  }, []);

  const orderDataByCol = async (colName) => {
    props.setOrderList(colName);
    await props.GetOrgUserList();
  };

  const getUpdatablePermissions = async (user) => {
    props.setSelectedUser(user);
    await props.getUpdatablePermissionsByUser(user);
  };

  const displayUserByPage = async (pageNo, showPrev = false) => {
    var users;
    setShowPrevList(showPrev);
    props.setCurrentPage(pageNo);
    var x = pageNo * userPerPage;
    if (showPrev) {
      users = props.data.tempUsersList.slice(x, x + userPerPage);
    } else {
      users = props.data.usersList.slice(x, x + userPerPage);
    }
    setUsersToDisplay(users);
  };

  const loadPrevData = async () => {
    var page = props.data.currentPage - 1;
    var displayPrevList = isDisplayPrevList();
    if (page == -1 && props.data.currentDataIndex > 0) {
      page = countOfPagePerLoad - 1;
      props.setCurrentDataIndex(props.data.currentDataIndex - 1);
    }
    displayUserByPage(page, displayPrevList);

    //offset to load prev data
    if (props.data.currentPage + 1 == preloadPageOffset) {
      if (displayPrevList) {
        props.resetTempList();
        setShowPrevList(false);
        props.setDataIndexToLoad(props.data.currentDataIndex - 2);
      } else {
        var alreadyLoaded = props.data.dataIndexToLoad == props.data.currentDataIndex - 1;
        if (!alreadyLoaded) {
          props.setDataIndexToLoad(props.data.currentDataIndex - 1);
        }
      }
      if (props.data.currentDataIndex > 0) await props.GetOrgUserList();
    }
  };

  const loadNextData = async () => {
    var page = props.data.currentPage + 1;
    var displayPrevList = showPrevList;
    if (page < totalPages) {
      if (showPrevList && page == countOfPagePerLoad) {
        page = 0;
        displayPrevList = false;
        props.setCurrentDataIndex(props.data.currentDataIndex + 1);
      }
      displayUserByPage(page, displayPrevList);
      if (page == countOfPagePerLoad && !showPrevList) {
        props.setUsersList();
        props.setCurrentPage(0);
      } else if (page == countOfPagePerLoad - preloadPageOffset) {
        var alreadyLoaded = props.data.dataIndexToLoad == props.data.currentDataIndex + 1;
        if (!showPrevList) {
          if (!alreadyLoaded) {
            props.setDataIndexToLoad(props.data.currentDataIndex + 1);
            await props.GetOrgUserList();
          }
        }
      }
    }
  };

  const getDisplayedPages = () => {
    var currentPage = props.data.currentPage + 1;
    if (totalPages <= 3) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    } else if (currentPage + 2 >= totalPages) {
      return [totalPages - 2, totalPages - 1, totalPages];
    } else {
      return [currentPage, currentPage + 1, currentPage + 2];
    }
  };

  const isDisplayPrevList = () => {
    if (!showPrevList) {
      if (props.data.currentPage == 0 && props.data.tempUsersList.length > 0) {
        return true;
      }
    } else {
      if (props.data.currentPage == 0) {
        return false;
      }
      return true;
    }
    return false;
  };
  return (
    <div className='orgUsersManagement'>
      <div className='L_title'>צפייה בדו"חות פיצול</div>
      <div className='M_title'>אנא בחר עובד מתוך הרשימה</div>
      
      <div className='table_container'>
        <FilterTable setSearchErrValue={setSearchErrValue} allowActivate={props.allowActivate} allowUpgrade={props.allowUpgrade} />
        <>
          {props.data.countOfRows == 0 ? (
            <div className='noFoundData'>
              <Image src={require('./icons/error.svg')}/>
              <p className='bold'>{Error.noDataFoundBySearch}</p>
              {searchErrValue && <p> "{searchErrValue}"</p>}
            </div>
          ) : (
            <table className='table'>
              <thead>
                <tr>
                  {UserTableColumn.map((item, index) => (
                    <th scope='col' key={index} width={`${item.width}`}>
                      {item.name}
                      {item.enableFilter && (
                        <Image className='filterArrow' src={require('./icons/orderArrow.svg')} onClick={() => orderDataByCol(item.value)} />
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <div className='tableBody_container' ref={containerRef}>
                <tbody>
                  {usersToDisplay.map((user, userIndex) => (
                    <tr key={userIndex} onClick={() => getUpdatablePermissions(user)}>
                      {UserTableColumn.map((col, colIndex) => (
                        <td width={`${col.width}`} key={colIndex}>
                          <div
                           className={`nowrap ${col.className}`}
                            style={{ backgroundColor: col.value == 'status' ? user[col.value] ? getStatusTextAndColor(user[col.value]).color : 'white' : 'white' }}>
                            {col.value === 'actionType'
                              ? user[col.value] === 'activate'
                                ? 'אקטוב'
                                : user[col.value] === 'upgrade'
                                  ? 'שדרוג'
                                  : ''
                              : col.value === 'fullName' && !user[col.value]?.trim()
                                ? '-'
                                : user[col.value]}
                          </div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </div>
            </table>
          )}
        </>

        <div className='footer_table'>
          {props.data.countOfRows >= userPerPage && (
            <p className='data_counter'>
              מציג {usersToDisplay.length} מתוך {props.data.countOfRows}
            </p>
          )}
          {totalPages > 1 && (
            <div className='pagination_button'>
              <Image
                className={`${props.data.currentPage == 0 && props.data.currentDataIndex == 0 ? 'disable' : ''}`}
                onClick={() => loadPrevData()}
                src={require('./icons/arrow-right.svg')}
              />
              {getDisplayedPages().map((page, index) => {
                return (
                  <span
                    className={`page_number
                  ${page == props.data.currentPage + 1 ? 'bold' : ''}`}
                    key={index}>
                    {props.data.currentDataIndex * countOfPagePerLoad + page}
                  </span>
                );
              })}
              <Image
                className={`${props.data.currentPage + 1 == totalPages ? 'disable' : ''}`}
                onClick={() => loadNextData()}
                src={require('./icons/arrow-left.svg')}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    data: state.orgUsersManagement,
    actionType: state.orgUsersManagement.actionType,
  };
};
const mapDispatchToProps = {
  getUpdatablePermissionsByUser,
  GetOrgUserList,
  setOrderList,
  saveToHistory,
  setFilterList,
  setCurrentPage,
  setUsersList,
  setDataIndexToLoad,
  setSelectedUser,
  resetTempList,
  setCurrentDataIndex,
  setActionType,
};
export default connect(mapStateToProps, mapDispatchToProps)(OrgUsersTable);
